/**
 * The category names the Cash Position report buckets projections by — twin of
 * the names matched in `get_cash_position_summary`. Names are contracts
 * ([ADR 0005](../../../../docs/adr/0005-category-names-are-contracts.md)): a
 * renamed category silently drops out of the report and these lists.
 */
export const REPORT_CATEGORY_NAMES = [
  'DEPOSIT',
  'ACCTS PAYABLE',
  'PAYROLL',
  'CREDIT CARD',
  'MGMT FEE',
  'DISTRIBUTION',
  'RENT',
  'ESCROW',
  'CAP EX',
  'CHARGEBACKS',
  'UNSPECIFIED',
  'INTER CO LOAN',
  'LINE OF CREDIT',
] as const

export type ReportCategoryName = (typeof REPORT_CATEGORY_NAMES)[number]

/** The ten categories summed into "Projected Outflows", in report order. */
export const OUTFLOW_CATEGORY_NAMES = [
  'ACCTS PAYABLE',
  'PAYROLL',
  'CREDIT CARD',
  'MGMT FEE',
  'DISTRIBUTION',
  'RENT',
  'ESCROW',
  'CAP EX',
  'CHARGEBACKS',
  'UNSPECIFIED',
] as const satisfies readonly ReportCategoryName[]

export type OutflowCategoryName = (typeof OUTFLOW_CATEGORY_NAMES)[number]

/** Row labels as the report spells them; `UNSPECIFIED` is "Minimum Daily Bank Balance" (ADR 0005). */
export const REPORT_CATEGORY_LABEL: Record<ReportCategoryName, string> = {
  DEPOSIT: 'Deposit',
  'ACCTS PAYABLE': 'Accts Payable',
  PAYROLL: 'Payroll',
  'CREDIT CARD': 'Credit Card',
  'MGMT FEE': 'Mgmt Fee',
  DISTRIBUTION: 'Distribution',
  RENT: 'Rent',
  ESCROW: 'Escrow',
  'CAP EX': 'Cap Ex',
  CHARGEBACKS: 'Chargebacks',
  UNSPECIFIED: 'Minimum Daily Bank Balance',
  'INTER CO LOAN': 'Inter Co Loan',
  'LINE OF CREDIT': 'Line of Credit',
}

export function isOutflowCategoryName(name: string): name is OutflowCategoryName {
  return (OUTFLOW_CATEGORY_NAMES as readonly string[]).includes(name)
}
